export enum enumBondType {
  CONTINUOUS = 8,
  SINGLE_TRANSACTION = 9,
}
